import moment from 'moment-jalaali';
import i18n from '../Locales/i18n';

export const sortOptions = [
  { label: i18n.t('credits.highestCredit'), value: 'highestCredit' },
  {
    label: i18n.t('credits.highestDiscountPercentage'),
    value: 'highestDiscountPercentage'
  },
  { label: i18n.t('credits.minimumDeadline'), value: 'minimumDeadline' }
];

export const creditHistoryOptions = [
  { label: i18n.t('credits.used'), value: 'used' },
  {
    label: i18n.t('credits.expired'),
    value: 'expired'
  }
];

// calculate days between today and expiration date
export const calculateCreditDays = (expirationDate: string) => {
  const expirationDateTimestamp = new Date(
    moment(expirationDate, 'jYYYY/jjM/jjD')
      .locale('en')
      .format('YYYY-MM-DD')
      .trim()
  ).getTime();
  const todayTimestamp = new Date().getTime();
  const timeDifference = expirationDateTimestamp - todayTimestamp;
  const oneDayTimestamp = 1000 * 60 * 60 * 24;
  return Math.floor((timeDifference + oneDayTimestamp) / oneDayTimestamp);
};
